import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    background: "#ffffff",
    minHeight: "calc(100vh - 100px)",
  },
  button: {
    marginTop: 16,
  },
  typography: {
    marginTop: theme.spacing(2),
  },
  link: {
    color: "green",
  },
  errorMessage: {
    color: "red",
    paddingTop: "1%",
    textAlign: "center",
  },
  button_container: {
    marginTop: 16,
    display: "flex",
    gap: theme.spacing(4),
  },
}));

export default useStyles;
